
<template>
    <div class="row qr-ct justify-content-center hcol-4">
        <div class="col-7 text-center d-flex align-items-center">
            <div class="img-ct" style="width: 100%">
                <vue-qrcode v-if="qrcode" :value="qrcode" :options="{ width: 1000, scale: 1 }" :key="key" />
            </div>
        </div>
    </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
export default {
  components: {
      VueQrcode
  },
  props: [
    "qrcode"
  ],
  data () {
    return {
      key: 1
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
  },
  watch: {
    qrcode: function (val, oldVal) {
      Vue.set(this, 'key', this.key + 1);
    }
  }
}
</script>

<style scoped lang="scss">
 canvas {
  width: 100% !important;
  height: 100% !important;
 }
</style>